/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-useless-escape */
import { isObject } from 'lodash'

const validate = values => {
  const errors = {}
  if (!values.firstName) {
    errors.firstName = 'Field shouldn’t be empty'
  }
  if (!/^[a-zA-Z0-9]{0,255}$/.test(values.coupon)) {
    errors.coupon = 'Invalid format.'
  }
  if (!values.deletion) {
    errors.deletion = 'Field shouldn’t be empty'
  }
  if (!values.lastName) {
    errors.lastName = 'Field shouldn’t be empty'
  }
  if (!values.email) {
    errors.email = 'Email field shouldn’t be empty'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,12}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  if (!values.url) {
    errors.url = 'Url field shouldn’t be empty'
  } else if (
    !/^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i.test(
      values.url
    )
  ) {
    errors.url = 'Invalid url'
  }
  if (!values.password) {
    errors.password = 'Password field shouldn’t be empty'
  }
  if (!values.confirm) {
    errors.confirm = 'You should confirm your new password'
  } else if (values.confirm !== values.password) {
    errors.confirm = 'The password and confirmation password do not match'
  }
  if (!values.select) {
    errors.select = 'Please select the option'
  }
  if (!values.spotifyURL) {
    errors.spotifyURL = 'Field shouldn`t be empty'
  } else if (
    !values.spotifyURL.includes('track') &&
    !values.spotifyURL.includes('album')
  ) {
    errors.spotifyURL = 'Invalid URL/URI'
  }
  if (!values.playlistURL) {
    errors.playlistURL = 'Field shouldn`t be empty'
  } else if (!/playlist/g.test(values.playlistURL)) {
    errors.playlistURL = 'Invalid URL/URI'
  }
  if (
    !/^[A-Z]{2}[a-zA-Z0-9 ]{12,40}$/.test(values.IBAN) &&
    !/^IL\d{2}([-_\s]?\d{4}){4}[-_\s]?\d{3}$/.test(values.IBAN)
  ) {
    errors.IBAN = 'Invalid IBAN number.'
  }
  if (!/^\d{2}-?\d{2}-?\d{2}$/.test(values.sortCode)) {
    errors.sortCode = 'Invalid sort code number.'
  }
  if (!/^[A-Za-z]{6}[A-Za-z\d]{2}([A-Za-z\d]{3})?$/.test(values.BIC)) {
    errors.BIC = 'Invalid format.'
  }
  if (!/^[a-zA-Z0-9 -+.@_-]{4,255}$/.test(values.accountNumber)) {
    errors.accountNumber = 'Invalid account number.'
  }
  if (!/[0-9]{9}/.test(values.abartn)) {
    errors.abartn = 'Invalid format.'
  }
  if (!isObject(values.bankCode) && !/^\d{4,40}$/.test(values.bankCode)) {
    errors.bankCode = 'Invalid format.'
  }
  if (
    !/^[a-zA-Z]{6}(([a-zA-Z0-9]{2})|([a-zA-Z0-9]{5}))$/.test(
      values.swiftCode
    ) &&
    !isObject(values.swiftCode)
  ) {
    errors.swiftCode = 'Invalid format.'
  }
  if (!/^\d{3,4}\-?\d{4}$/.test(values.bankgiroNumber)) {
    errors.bankgiroNumber = 'Invalid format.'
  }
  if (!/^\d{3}\-?\d{3}$/.test(values.bsbCode)) {
    errors.bsbCode = 'Invalid format.'
  }
  if (!/^\d{0,6}$/.test(values.prefix)) {
    errors.prefix = 'Invalid format.'
  }
  if (!/\d{3}/.test(values.institutionNumber)) {
    errors.institutionNumber = 'Invalid format.'
  }
  if (!/\d{5}/.test(values.transitNumber)) {
    errors.transitNumber = 'Invalid format.'
  }
  if (
    !/(([A-Za-z0-9_\-\.\+])*[A-Za-z0-9_]\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,63}))/.test(
      values.interacAccount
    )
  ) {
    errors.interacAccount = 'Invalid format.'
  }
  if (!/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/.test(values.ifscCode)) {
    errors.ifscCode = 'Invalid format.'
  }
  if (!/^\d{5}\s?\d{8}\s?\d{5}$/.test(values.clabe)) {
    errors.clabe = 'Invalid format.'
  }
  if (!/^[0-9Kk\.\-]{8,12}$/.test(values.rut)) {
    errors.rut = 'Invalid format.'
  }
  if (!/^\d{2}\-?\d{8}\-?\d$/.test(values.taxId)) {
    errors.taxId = 'Invalid format.'
  }
  if (!/^((\+)|(00))?[0-9]{9,15}$/.test(values.phoneNumber)) {
    errors.phoneNumber = 'Invalid phone number number.'
  }
  if (!/^\d{4}\-\d{2}\-\d{2}$/.test(values.dateOfBirth)) {
    errors.dateOfBirth = 'Invalid date format. Example: YYYY-MM-DD.'
  }
  if (!/^(\*{12,15}\d{4})|([0-9]{16,19})$/.test(values.cardNumber)) {
    errors.cardNumber = 'Invalid card number format.'
  }
  return errors
}

export default validate
